<template>
  <div id="my_search_input_outer">
    <input type="text" placeholder="输入关键字搜索" v-model="keyword" @keyup.enter="searchClose" >
    <a class="iconfont" style="color: white;font-size: 2rem;" href="javascript:void (0);" @click="searchClose">&#xe615;</a>
  </div>
</template>

<script>
import GlobalInstance from "../../js/shba";

export default {
  name: "SearchInput",
  data() {
    return {
      keyword: '',
    }
  },
  methods: {
    searchClose() {
      if (this.keyword != '') {
        GlobalInstance.search.searchClose(this.$router, this.keyword);
      }
    }
  }
}
</script>

<style scoped>

  #my_search_input_outer {
    background-color: rgba(255,255,255, 0.3);
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: center;
    border-radius: 20px;
    padding-left: 23px;
    padding-right: 23px;
    margin-right: 15px;
  }

  #my_search_input_outer input {
    display: block;
    outline: none;
    border: none;
    font-size: 1rem;
    color: white;
    background-color: transparent;
    height: 45px;
    letter-spacing: 3px;
    width: 15vw;
  }
  #my_search_input_outer input::-webkit-input-placeholder {
    color: white;
  }

  #my_search_input_outer a {
    display: block;
    margin-left: 0;
    text-decoration: none;

  }

</style>



// WEBPACK FOOTER //
// src/components/search/SearchInput.vue